<template>
<easy-data-table
	class="data-table m-1 mt-1 me-1"
	table-class-name="customize-table"
	:headers="tableHeaders"
	:items="tableItems"
	:loading="tableItems.length == 0"
	theme-color="rgb(198, 199, 200)"
	:hide-footer="true"
	:table-min-height="380"
	:table-height="easyDataTableHeight(false)"
	:prevent-context-menu-row="false"
	:rows-per-page="tableItems.length"
	alternating
>
	<!-- If rows is empty -->
	<template #empty-message>
		Записів не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Name item customization -->
	<template #item-name="{ name }">
		<b class="fw-border">{{ name }}</b>
	</template>
</easy-data-table>
</template>




<script>
import { SECTOR_TITLE, DEPARTMENT_TITLE } from '@/app.conf'
import { useStationsStore } from '@/stores/StationsStore.js'
import { usePostsStore } from '@/stores/PostsStore.js'
import {
	easyDataTableHeight,
	chartDateStr,
} from '@/helpers.js'
import { FIELD_NAMES, parseApiTimeDate, } from '@/api/rest.js'
import { Post } from '@/models/post.js'


export default {
	components: {
	},

	props: {
		postId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const stationsStore = useStationsStore()
		const postsStore = usePostsStore()

		return {
			stationsStore,
			postsStore,
			easyDataTableHeight,
		}
	},

	data() {
		return {
			// Table
			tableHeaders: [
				{ text: "Назва", value: "name", },
				{ text: "Значення", value: "value" },
			],
		}
	},

	async created() {
		if (this.stationsStore.isNoStations) {
			// Read all stations
			await this.stationsStore.readStations()
		}
	},

	mouted() {},

	methods: {
		parseSettingValue(id, value) {
			if (value === true || value === false) {
				return [
					Post.settingNames[id] ?? id,
					Post.flagText(value),
				]
			}

			switch (id) {
				case Post.passportKeys.installationDate:
				case Post.passportKeys.produceDate:
					return [
						Post.settingNames[id],
						value ? chartDateStr(parseApiTimeDate(value)) : '-',
					]
				case Post.passportKeys.location:
					return [
						Post.settingNames[id],
						`${value?.coordinates[0]} ${value?.coordinates[0]}`,
					]
				case Post.passportKeys.controlType:
					return [
						Post.settingNames[id],
						Post.postControlType[value].title
					]
				case Post.passportKeys.relatedStations:
					return [
						Post.settingNames[id],
						this.stationsStore.stationsArray
							.filter((station) => value.includes(station.id))
							.map((station) => `"${station.shortName ? station.shortName : station.name}"`)
							.join(',\xa0\xa0\xa0\xa0 '),
					]
				case Post.passportKeys.departmentId:
					return [
						Post.settingNames[id],
						value?.title ?? DEPARTMENT_TITLE ,
					]
				case Post.passportKeys.sectorId:
					return [
						Post.settingNames[id],
						value?.title ?? SECTOR_TITLE,
					]
				case Post.passportKeys.pipelineId:
					return [
						Post.settingNames[id],
						this.pipelines
							.filter((el) => value.includes(el.id))
							.map((el) => el.title),
					]
				default:
					return [
						Post.settingNames[id] ?? id,
						value,
					]
			}
		},
	},

	computed: {
		post() { return this.postsStore.post(this.postId) },

		pipelines() {
			const passport = Object.fromEntries(
				this.postsStore.post(this.postId).passport
			)

			return passport[Post.passportKeys.org]['pipelines']
		},

		tableItems() {
			const items = []
			const passport = Object.fromEntries(
				this.postsStore.post(this.postId).passport
			)

			console.log('passport', Object.fromEntries(this.postsStore.post(this.postId).passport))

			// Normalize
			for (const field of Object.values(FIELD_NAMES)) {
				delete passport[field]
			}
			delete passport[Post.passportKeys.updateBy]
			delete passport[Post.passportKeys.creatorId]
			delete passport[Post.passportKeys.metricsId]
			passport[Post.passportKeys.orgId] = passport[Post.passportKeys.orgName]
			delete passport[Post.passportKeys.orgName]
			delete passport[Post.passportKeys.org]
			delete passport['_items']
			delete passport[Post.passportKeys.notificationDistributionLists.self]
			passport[Post.passportKeys.departmentId] = passport[Post.passportKeys.department]
			delete passport[Post.passportKeys.department]
			passport[Post.passportKeys.sectorId] = passport[Post.passportKeys.sector]
			delete passport[Post.passportKeys.sector]

			// console.log('passport', passport)
			// Enumerate all not unit items
			for (const [itemId, itemValue] of Object.entries(passport)) {
				const [name, value] = this.parseSettingValue(itemId, itemValue)
				items.push({
					name: name,
					value: value
				})
			}

			return items
		},
	},
}
</script>




<style src="@/assets/table.css" scoped />
<style scoped>

</style>